<script>
  import * as _ from "lodash";
  import ProductList from "@retailer/svelte/ListBuilder/Components/ProductPicker/ProductList.svelte";
  import VintagePicker from "@shared/svelte/Components/VintagePicker.svelte";
  import FizzStyles from "@shared/svelte/Components/FizzStyles.svelte";
  import { buildVintagesList, hasVintage } from "@retailer/services/vintages_service";

  export let list;
  export let placeholderProduct;
  export let kegs;
  export let bottles;
  export let cans;
  export let boxes;
  export let packages;
  export let items;
  export let products;
  export let isLoadingProductLineDetails;
  isLoadingProductLineDetails = isLoadingProductLineDetails;
  export let activeTab;
  export let onAddProductToList;
  export let onRemoveProductFromList;
  export let onProductPickerTabChange;
  export let productLine;

  let activePanes;
  let activeProducts;
  let selectedVintage;
  let vintages = buildVintagesList(products);

  $: {
    selectedVintage;
    activePanes = {};
    if (cans.length > 0) {
      activePanes["Cans"] = filterProducts(cans);
    }
    if (bottles.length > 0) {
      activePanes["Bottles"] = filterProducts(bottles);
    }
    if (boxes.length > 0) {
      activePanes["Boxes"] = filterProducts(boxes);
    }
    if (kegs.length > 0) {
      activePanes["Kegs"] = filterProducts(kegs);
    }
    if (packages.length > 0) {
      activePanes["Packages"] = filterProducts(packages);
    }
    if (items.length > 0) {
      activePanes["Items"] = filterProducts(items);
    }
    if (!activeTab) {
      activeTab = _.find(Object.keys(activePanes), function (pane) {
        return activePanes[pane].length > 0;
      });
    }
    activeProducts = activePanes[activeTab];
  }

  function handleTabChange(name) {
    onProductPickerTabChange(name);
  }

  function filterProducts(productsByContainer) {
    if (productLine.distributor_info.is_vintage_product && selectedVintage == null) {
      return [];
    }
    if (productLine.distributor_info.is_vintage_product && selectedVintage == "Current") {
      return _.filter(productsByContainer, function (p) {
        return p.vintage_year == null;
      });
    }

    return _.filter(productsByContainer, function (p) {
      return productLine.distributor_info.is_vintage_product
        ? p.vintage_year == selectedVintage
        : true;
    });
  }

  function selectVintage(vintage) {
    selectedVintage = vintage;
    activeTab = null;
  }
</script>

{#if Object.keys(activePanes).length === 0}
  <div class="margin--medium align-center secondary-title--regular">No available products</div>
{:else}
  {#if hasVintage(productLine.product_type_name, vintages)}
    <FizzStyles>
      <div class="fizz-center-content fizz-inset-square-16">
        <VintagePicker {vintages} {selectVintage} {selectedVintage} displayHeader={false} />
      </div>
    </FizzStyles>
  {/if}
  <div class="list-builder__container-tabs">
    <div class="ui pointing secondary menu">
      {#each ["Cans", "Bottles", "Boxes", "Kegs", "Packages", "Items"] as containerName}
        {#if (activePanes[containerName] || []).length > 0}
          <span
            on:click|preventDefault={() => {
              handleTabChange(containerName);
            }}
            class={`item ${activeTab === containerName ? "active" : ""}`}>{containerName}</span
          >
        {/if}
      {/each}
    </div>
    <div class="ui segment active tab">
      <ProductList
        {list}
        {placeholderProduct}
        products={activeProducts}
        {onAddProductToList}
        {onRemoveProductFromList}
      />
    </div>
  </div>
{/if}
